// extracted by mini-css-extract-plugin
export var isShowingMobileMap = "styles-module__isShowingMobileMap___kMYV9";
export var fullscreenSearchResults = "styles-module__fullscreenSearchResults___POs3m";